export const isMobileDevice = window.innerWidth < 768;

// make sure to turn this to false
const isLocal = false;
const serverPath = 'http://localhost/diamour-app/';

// send path without the leading '/'
export const baseUrl = function(path) {
  if (isLocal) {
  	return `${serverPath}${path}`;
  }
  return `${process.env.PUBLIC_URL}/${path}`;
};



export default {
  isMobileDevice,
  baseUrl
};